'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleCompareItem = toggleCompareItem;
exports.cancelCompare = cancelCompare;
var COMPARE_TOGGLE_ITEM = exports.COMPARE_TOGGLE_ITEM = 'COMPARE_TOGGLE_ITEM';
var COMPARE_CANCEL = exports.COMPARE_CANCEL = 'COMPARE_CANCEL';

function toggleCompareItem(_ref) {
  var type = _ref.type,
      id = _ref.id,
      limit = _ref.limit;

  return {
    type: COMPARE_TOGGLE_ITEM,
    id: id,
    itemType: type,
    limit: limit
  };
}

function cancelCompare() {
  return {
    type: COMPARE_CANCEL
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Compare/actions.js
// module id = 828
// module chunks = 0